import { useState } from 'react'

import { MembersDropdown } from '../../../../../components/shared/members-dropdown'
import type { ShipmentStatusEnum, TShipmentMember } from '../../../../../types/shipment'
import { DispatchersList } from './dispatchers-list'

interface IShipmentDispatchers {
  dispatchers: TShipmentMember[]
  shipmentID: string
  shipmentNumber: string
  shipmentStatus: ShipmentStatusEnum
  workspaceID: string
}

/**
 * This component is used to display a dropdown to select dispatchers for a shipment.
 */
export const ShipmentDispatchers = ({
  dispatchers,
  workspaceID,
  shipmentID,
  shipmentNumber,
  shipmentStatus
}: IShipmentDispatchers) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpenChange = () => {
    setIsOpen(!isOpen)
  }

  const selectedUsersAvatar = dispatchers?.map((user) => {
    return {
      ...user.user
    }
  })

  return (
    <div className="relative w-full">
      <MembersDropdown
        isOpen={isOpen}
        handleOpenChange={handleOpenChange}
        buttonText={'Add Dispatchers'}
        selectedUsersAvatar={selectedUsersAvatar}
        popoverContent={
          <DispatchersList
            dispatchers={dispatchers || []}
            onClose={handleOpenChange}
            shipmentID={shipmentID}
            shipmentNumber={shipmentNumber}
            workspaceID={workspaceID}
            shipmentStatus={shipmentStatus}
          />
        }
      />
    </div>
  )
}
